/** MLS (Giełda Współpracy) admin routes **/
import Layout from '@/layout';

const mlsRoutes = {
  path: '/mls',
  component: Layout,
  redirect: '/mls/access-requests',
  name: 'Mls',
  alwaysShow: true,
  meta: {
    title: 'MLS',
    icon: 'el-icon-share',
    permissions: ['manage user'],
  },
  children: [
    {
      path: 'access-requests',
      component: () => import('@/views/mls/AccessRequests'),
      name: 'MlsAccessRequests',
      meta: {
        title: 'Prośby o dostęp',
        icon: 'el-icon-key',
        noCache: true,
        permissions: ['manage user'],
      },
    },
  ],
};

export default mlsRoutes;
